import { UnderstandingResultEntityModel } from "src/store/models/entity/understandingResult/entity";
import { UnderstandingResultHelperModel } from "src/store/models/entity/understandingResult/helper";

export const encooUnderstandingResultModels = {
  entity: UnderstandingResultEntityModel,
  helper: UnderstandingResultHelperModel,
};
